module.exports = __webpack_public_path__ + "static/designig-dee3a43ec86eadd3a28d304bc45df1ec.svg";